/** @jsxImportSource @emotion/react */
import { optionCSS } from "@/app/components/form-fields/select/styling";
import { WithMenu } from "@/app/components/form-fields/select/WithMenu";
import { css } from "@emotion/react";
import { ChevronRightIcon } from "@saas-ui/core";
import * as React from "react";

interface SubMenuFullProps {
  label: string;
  children?: React.ReactNode;
}

export const SubMenuFull = React.forwardRef<
  HTMLDivElement,
  SubMenuFullProps & React.ComponentPropsWithoutRef<"div">
>(({ children, label }, ref) => {
  return (
    <WithMenu
      render={(props, ref) => (
        <SubMenu ref={ref} {...props}>
          {label}
        </SubMenu>
      )}
    >
      {children}
    </WithMenu>
  );
});

export const SubMenu = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div">
>(({ children, ...props }, ref) => {
  const [isFocused, setIsFocused] = React.useState(false);
  return (
    <div
      {...props}
      ref={ref}
      css={css(optionCSS(false, isFocused, false))}
      onMouseEnter={() => setIsFocused(true)}
      onMouseLeave={() => setIsFocused(false)}
      data-cy={`custom-select-group-${children}`}
    >
      <div className="flex justify-between items-center w-full">
        {children}
        <ChevronRightIcon />
      </div>
    </div>
  );
});
